import { useRef, useState } from "react";

const now = () => new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

// Cross-cutting user feedback: the bottom toast banner and the "Saved …"
// footer indicator, both used across the dashboard, application form,
// document tagging and post-application flows.
export default function useUiFeedback() {
  const [toast, setToast] = useState(null);
  const [savedAt, setSavedAt] = useState("All changes saved");
  const toastTimer = useRef(null);

  const flash = (m) => {
    setToast(m);
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(null), 2200);
  };

  const touchSaved = () => setSavedAt("Saved " + now());

  return { toast, flash, savedAt, setSavedAt, touchSaved };
}
